// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__90x-C","top":"styles_top__2Dgxd"};